import { Routes } from 'app/routes/Routes'
import { treeRenderer } from 'app/routes/TreeRenderer'
import * as React from 'react'
import { Navigate, Route, Routes as Switch, useParams } from 'react-router-dom'

import { routes } from './RoutesConfig'

const Redirect = () => {
  const { checkout_id } = useParams<{ checkout_id: string }>()

  return <Navigate to={Routes.Checkout.member(checkout_id).address} />
}

const Root = () => {
  const tree = React.useMemo(() => treeRenderer(routes), [])

  return (
    <Switch>
      <Route
        key="checkout-redirect"
        path={`${Routes.Checkout.member(undefined, false).show}`}
        element={<Redirect />}
      />
      {tree}
    </Switch>
  )
}

export default Root
